/**
 * downloads a file using an anchor tag and provided href/fileUrl
 * @param fileUrl string for href
 * @param fileName name of the file to be downloaded as
 */
export const downloadFile = (fileUrl: string, fileName: string) => {
  const a = Object.assign(document.createElement('a'), {
    href: fileUrl,
    download: fileName,
  });
  document.body.appendChild(a);
  a.click(); a.remove();
};
